<div id="app-footer" class="layout-footer">
    <div class="footerMain footerInner">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 noLeftPadding">
                <p>Powered by <a href="https://openbots.ai/">OpenBots.AI</a></p>
            </div>
        </div>
    </div>
</div>
